import React from 'react';
import './Footer.css';
import LogoMark from './LogoMark';

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'About', section: 'about' },
    { label: 'Services', section: 'services' },
    { label: 'Our Method', section: 'method' },
    { label: 'Case Studies', section: 'cases' },
    { label: 'Leadership', section: 'founder' },
  ];

  return (
    <footer>
      <div className="fi">
        <div className="ft">
          <div>
            <LogoMark />
            <div className="ftg">Corporate Strategy &amp; Business Development across India, Middle East &amp; Africa.</div>
          </div>
          <div>
            <div className="fct2">Navigation</div>
            {navLinks.map((link) => (
              <a
                key={link.section}
                className="fl"
                href={`#${link.section}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.section);
                }}
              >
                {link.label}
              </a>
            ))}
          </div>
          <div>
            <div className="fct2">Contact</div>
            <a className="fl" href="tel:+918454060578">+91 84540 60578 (India)</a>
            <a className="fl" href="tel:+971501741137">+971 50 174 1137 (Dubai)</a>
            <a className="fl" href="mailto:businessdevelopment@stratx.us">businessdevelopment@stratx.us</a>
            <a className="fl" href="https://www.stratx.us" target="_blank" rel="noopener noreferrer">www.stratx.us</a>
          </div>
        </div>
        <div className="fb2">
          <div className="fcp">&copy; {new Date().getFullYear()} StratX. All rights reserved.</div>
          <div className="fcr">
            <a href="https://www.omatechdigital.com" target="_blank" rel="noopener noreferrer">Omatech Digital</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
